<template>
  <div class="intro-y grid grid-cols-12 gap-6">
    <div class="col-span-12 lg:col-span-8">
      <OfficerPerformance :officer="officer" />
    </div>
    <div class="col-span-12 lg:col-span-4">
      <OfficerNotesWithDeadLine :officer="officer" :title="$t('text.haveDeadline')" />
    </div>
  </div>
</template>

<script>
import OfficerPerformance from '@/components/officer/OfficerPerformance';
import OfficerNotesWithDeadLine from '@/components/officer/OfficerNotesWithDeadline';
import dataListMixin from '@/mixins/dataListMixin';

export default {
  mixins: [dataListMixin],

  props: {
    officer: Object,
  },

  components: {
    OfficerPerformance,
    OfficerNotesWithDeadLine,
  },
};
</script>
